import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { environment } from '../environments/environment'; 

import { AngularFireModule } from '@angular/fire';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFireAuthModule } from '@angular/fire/auth';

import { CharacterPageModule } from './character/character.module';
import { ModalSelectPageModule } from './modal-select/modal-select.module';

import { SelectWeaponsPageModule } from './select-weapons/select-weapons.module';
import { SelectProgramsPageModule } from './select-programs/select-programs.module';
import { RolesPageModule } from './roles/roles.module';
import { StatsPageModule } from './stats/stats.module';
import { SkillsPageModule } from './skills/skills.module';
import { LifepathPageModule } from './lifepath/lifepath.module';
import { GearPageModule } from './gear/gear.module';
import { SelectWeaponsOptionsPageModule } from './select-weapons-options/select-weapons-options.module';
import { SelectArmorPageModule } from './select-armor/select-armor.module';
import { SelectCyberwarePageModule } from './select-cyberware/select-cyberware.module';
import { SelectCyberwareOptionsPageModule } from './select-cyberware-options/select-cyberware-options.module';
import { SelectGearPageModule } from './select-gear/select-gear.module';
import { SelectLifepathPageModule } from './select-lifepath/select-lifepath.module';
import { ImageCropperPageModule } from './image-cropper/image-cropper.module';
import { PersonalPageModule } from './personal/personal.module';




@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
    imports: [BrowserModule, IonicModule.forRoot(), AppRoutingModule,
        AngularFireModule.initializeApp(environment.firebase),
        AngularFireDatabaseModule,
        AngularFireStorageModule,
        AngularFireAuthModule,
        HttpClientModule,
        ModalSelectPageModule,
        CharacterPageModule,
        SelectWeaponsPageModule,
        SelectWeaponsOptionsPageModule,
        SelectArmorPageModule,
        SelectCyberwarePageModule,
        SelectCyberwareOptionsPageModule,
        SelectGearPageModule,
        SelectLifepathPageModule,
        RolesPageModule,
        StatsPageModule,
        SkillsPageModule,
        LifepathPageModule,
        GearPageModule,
        ImageCropperPageModule,
        PersonalPageModule,
        SelectProgramsPageModule
    ],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
